import { useEffect } from "react";
import { useFetchCsrfQuery } from "@/src/auth/services/auth-http.service";
import { getCsrfToken, getIsAuthenticated } from "@/src/auth/store/auth-selectors";
import { setCsrfToken } from "@/src/auth/store/auth-slice";
import { useAppDispatch, useAppSelector } from "@/src/common/redux/store";

export function AuthBootstrap() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const csrfToken = useAppSelector(getCsrfToken);
	const dispatch = useAppDispatch();
	const shouldFetch = isAuthenticated && !csrfToken;
	const { data } = useFetchCsrfQuery(undefined, { skip: !shouldFetch });

	useEffect(() => {
		if (data?.csrf_token) {
			dispatch(setCsrfToken(data.csrf_token));
		}
	}, [data, dispatch]);

	return null;
}
